import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import Container from "../components-layout/Container"
import GridSolicitudCuotasMes from './AdmisionesCuotasMes'

export default function ModasCuotasMes({ open, setOpen, cuotasmes = [] }) {

    return (
        <Container height='h-full'>
            <Transition.Root appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="lg:w-[100%] lg:h-[100%] sm:h-[100%] p-6">
                                    <div className='mt-2'>
                                        <GridSolicitudCuotasMes
                                            cuotas={cuotasmes}
                                            setOpen={setOpen}
                                        />
                                    </div>
                                    <div className='flex min-h-full items-end justify-center text-center p-4 sm:items-center sm:p-0'>
                                        <button
                                            type="button"
                                            className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                            onClick={() => setOpen(false)}
                                        >
                                            Regresar
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Container >
    )
}